import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  GeneralToastSliceinitialStateInterface,
  IToasterContent,
} from "../../types/reduxSlices";

const initialState: GeneralToastSliceinitialStateInterface = {
  ToasterContent: {
    title: "",
    desc: "",
    duration: 0,
    img: null,
    position: "top-right",
    type: "success",
  },
  disableCancel: false,
};

const generalToastSlice = createSlice({
  name: "generalToast",
  initialState,
  reducers: {
    ToggleShowGeneralToast: (
      state,
      action: PayloadAction<
        Partial<{
          ToasterContent: IToasterContent;
          disableCancel: boolean;
        }>
      >,
    ) => {
      const { ToasterContent, disableCancel } = action.payload;

      if (disableCancel) {
        state.disableCancel = disableCancel;
      }
      if (ToasterContent) {
        state.ToasterContent = ToasterContent;
      }
    },
  },
});

export const { ToggleShowGeneralToast } = generalToastSlice.actions;

export default generalToastSlice.reducer;
